document.getElementById("openModal").onclick = function () {
  document.getElementById("paymentModal").style.display = "block";
  document.documentElement.style.overflow = "hidden";
};

document.querySelector(".payment-close").onclick = function () {
  document.getElementById("paymentModal").style.display = "none";
  document.documentElement.style.overflow = "auto";
};

window.onclick = function (event) {
  if (event.target == document.getElementById("paymentModal")) {
    document.getElementById("paymentModal").style.display = "none";
    document.documentElement.style.overflow = "auto";
  }
};
